import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import HomePage from "./Components/HomePage/HomePage";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import AboutUs from "./Components/AboutUs/AboutUs";
import ContactUs from "./Components/ContactUs/ContactUs";
import Shop from "./Components/Shop/Shop";
import Gallary from "./Components/Gallary/Gallary";
import ScrollToTop from "./ScrollToTop";
import Login from "./Components/Auth/Login";
import SignUp from "./Components/Auth/SignUp";
import UserDashboard from "./Components/UserDashboard/UserDashboard";
import AdminDashboard from "./Components/AdminDashboard/AdminDashboard";
import PaintingDetails from "./Components/Shop/PaitingDetailsPage";
import CartPage from "./Components/Shop/CartPage";
import CheckoutPage from "./Components/Shop/CheckoutPage";
import ThankYouPage from "./Components/Shop/ThankyouPage";
import RefundPolicy from "./Components/HomePage/RefundPolicy";
import FAQs from "./Components/HomePage/Faq";
import Disclaimer from "./Components/HomePage/Disclaimer";
import PrivacyPolicy from "./Components/HomePage/PrivacyPolicy";
import { Context } from "./Context/ContextApi";
import { useState, useEffect } from "react";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import ForgotPassword from "./Components/Auth/ForgotPassword";
import ResetPassword from "./Components/Auth/ResetPassword";
function App() {

  const allPaintings = [
    { id: 1, title: "Madhubani Art", image: "../Images/gallary-1.jpg" },
    { id: 2, title: "Gond Art", image: "../Images/gallary-2.jpg" },
    { id: 3, title: "Pattachitra Painting", image: "../Images/gallary-3.jpg" },
    { id: 4, title: "Handmade Home Decor", image: "../Images/gallary-4.jpg" },
    { id: 5, title: "Vastu Painting", image: "../Images/gallary-5.jpg" },
    { id: 6, title: "Buddha Painting", image: "../Images/gallary-6.jpg" },
    { id: 7, title: "Modern Abstracts", image: "../Images/gallary-7.jpg" },
    { id: 8, title: "Living Room Painting", image: "../Images/gallary-8.jpg" },
  ];

  const [painting, setPainting] = useState(allPaintings)
  const [slide, setSlide] = useState([])
  const [category, setCategory] = useState([])
  const [featuredPaintings, setFeaturedPaintings] = useState([])
  const [homeProducts, setHomeProducts] = useState([])
  const [detailProduct, setDetailProduct] = useState([])

  useEffect(() => {

    axios.get("https://admin.tulikaarts.in/api/slider")
      .then((response) =>
        setSlide(response)
      )
      .catch((error) => console.log(error))

  }, [])


  useEffect(() => {
    axios.get("https://admin.tulikaarts.in/api/category")
      .then((response) =>
        setCategory(response))
      .catch((error) => console.log(error))
  }, [])


  useEffect(() => {
    axios.get("https://admin.tulikaarts.in/api/featured-painting")
      .then((response) =>
        setFeaturedPaintings(response))
      .catch((error) => console.log(error))
  }, [])

  useEffect(() => {
    axios.get("https://admin.tulikaarts.in/api/home-product")
      .then((response) =>
        setHomeProducts(response))
      .catch((error) => console.log(error))
  }, [])

  useEffect(() => {
    axios.get("https://admin.tulikaarts.in/api/product-detail/painting-1")
      .then((response) =>
        setDetailProduct(response))
      .catch((error) => console.log(error))

  }, [])
  const [addresses, setAddresses] = useState([]);

  const getAddress = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: 'https://admin.tulikaarts.in/api/get-address',
      headers: {
        'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
      }
    };

    axios.request(config)
      .then((response) => {
        // console.log(JSON.stringify(response.data));
        setAddresses(response.data.addresses);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
  
          getAddress();
  }, [])
  
  
  const handleAddAddress = ({formData}) => {
    const id = toast.loading("Adding address...");
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://admin.tulikaarts.in/api/add-address',
      headers: {
        'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
      },
      data: formData
    };

    axios.request(config)
      .then((response) => {
        // console.log(JSON.stringify(response.data));
        setTimeout(() => {

          toast.success(response.data.message, { id });
          getAddress();
        }, 1000);
      })
      .catch((error) => {
        console.log(error);
        error.response.data.errors.forEach((error) => {
          toast.error(error, { id });
        });
      })
  };

  return (
    <div className="App">
      <Context.Provider value={{ painting, slide, category, featuredPaintings, homeProducts, detailProduct, getAddress, addresses, handleAddAddress }}>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/shop/:url?" element={<Shop />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/faq" element={<FAQs />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/painting/:id" element={<PaintingDetails />} />
            <Route path="/gallary" element={<Gallary />} />
            <Route path="/login" element={<Login />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/thankyou" element={<ThankYouPage />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/dashboard" element={<UserDashboard />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/forgot_password" element={<ForgotPassword />} />
            <Route path="/reset_Password/:token?" element={<ResetPassword />} />
          </Routes>
          <Toaster />
          <Footer />
        </BrowserRouter>
      </Context.Provider>
    </div>
  );
}

export default App;
